import * as React from "react";
import { sortBy } from "lodash";
import { JSX } from "react";
import { DashboardModel } from "@app/user/dashboardModel";
import { ClientService } from "@app/client/clientService";

export interface DashboardsProps {
  dashboards: DashboardModel[];
}

export const DashboardsContext = React.createContext<Partial<DashboardsProps>>({});

const clientService = new ClientService();
/**
 * This context serves to fetch the list of all dashboards from the API and keep them handy.
 * It does not reflect a given client's selected dashboards.
 */
export const DashboardsProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [dashboards, setDashboards] = React.useState<DashboardModel[]>([]);

  React.useEffect(() => {
    clientService.getAllDashboards().then((d) => setDashboards(sortBy(d, (dashboard) => dashboard.name, "asc")));
  }, []);

  return (
    <DashboardsContext.Provider
      value={{
        dashboards
      }}
    >
      { children}
    </DashboardsContext.Provider>
  );
};
